// extracted by mini-css-extract-plugin
export default {"title":"LogManagement_title__vTO6l"};